import classNames from 'classnames';
import { ProductWithBundleId } from '~/models/CampaignModel';
import { ProductType } from '../../../../../../models/product/ProductType';
import { FCC } from '../../../../../../utils/types';
import { SelectedIcon } from '../components/selection-icon/SelectedIcon';
import ProductPrice from '../product-cards/ProductPrice';
import './product-bundle.scss';

interface Props {
  selectedInBundle: ProductWithBundleId[];
}

const SelectedImage = ({ url, type, name }: { url: string; type: ProductType; name: string }) => {
  const styles = classNames('selected-product-image', type);
  return (
    <div>
      <img src={url} className={styles} alt={name} />
    </div>
  );
};

const SelectedProducts: FCC<Props> = ({ children, selectedInBundle }) => {
  return (
    <div className="selected-products">
      <SelectedIcon />
      {selectedInBundle?.map((product, key) => (
        <div key={key} className="selected-item">
          <SelectedImage url={product.displayData.imageUrl} type={product.productType} name={product.displayData.name} />

          <div className="selected-product-info">
            <div className="name">{product.displayData.name}</div>
            <ProductPrice pricing={product.pricing} receiver={product.productType === ProductType.Receiver} />
          </div>

          <div className="selected-product-buttons">{children}</div>
        </div>
      ))}
    </div>
  );
};

export default SelectedProducts;
